// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Rc","articleImagesWrap":"Sc","articleImage":"Tc","singleImage":"Uc"};